module.exports = __webpack_public_path__ + "static/media/mercantilLogo.97b96da4.png";